import React from 'react';
import Nav from 'react-bootstrap/Nav';
import SidebarContents from './sideBarContent';

const Sidebar = () => {
	return (
		<Nav className="page-left-section">
			<div className="page-left-section">
				<SidebarContents />
			</div>
		</Nav>
	);
};

export default Sidebar;
